var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('stat-card',{attrs:{"title":"Contractor Spend","color":"orange accent-1","amount":_vm.total,"icon":"directions_run","sub_title":""}}),_c('stat-card',{attrs:{"title":"GST on Contractor","color":"orange accent-2","amount":_vm.gst,"icon":"directions_run","sub_title":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }